import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { APP_CONFIG } from '../../../../config/app.config';
import { Icon, IconSize } from '@shared/icons';
import SalesOnboardingPanel from './SalesOnboardingPanel';

const SalesForecastOverlay: React.FC = () => {
  const colors = APP_CONFIG.ui.theme.colors;

  return (
    <SalesOnboardingPanel
      title="Generating your forecast"
      footer={
        <Stack direction="row" flex={1} gap={1} alignItems="flex-start">
          <Icon icon="AlertCircle" size={IconSize.MEDIUM} color={colors.secondaryText} />
          <Typography variant="body2" color={colors.secondaryText}>
            This usually takes a few minutes after your first sales import finishes.
          </Typography>
        </Stack>
      }
    >
      <Typography variant="body2" color="text.secondary">
        We&apos;re building your demand forecast from the sales data we just imported.
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          py: 4,
          border: `1px solid ${colors.border}`,
          borderRadius: '8px',
        }}
      >
        <CircularProgress size={32} />
        <Typography variant="body2" color="text.secondary">
          Creating forecast…
        </Typography>
      </Box>
    </SalesOnboardingPanel>
  );
};

export default SalesForecastOverlay;
